import { render, staticRenderFns } from "./CompanyPlan.vue?vue&type=template&id=39ed8a74&scoped=true&"
import script from "./CompanyPlan.vue?vue&type=script&lang=ts&"
export * from "./CompanyPlan.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyPlan.vue?vue&type=style&index=0&id=39ed8a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ed8a74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
